import Splide from '@splidejs/splide'
import GLightbox from 'glightbox'

export default (opts = {}) => ({
  opts: {
    perPage: 1,
    perMove: 1,
    pagination: false,
    arrows: false,
    ...opts,
  },
  splide: null,
  thumbnails: null,
  lightbox: null,
  currentIndex: 0,

  init() {
    if (this.splide !== null || this.thumbnails !== null) {
      return
    }

    this.splide = new Splide(this.$refs.mainCarousel, this.opts)
    this.thumbnails = new Splide(this.$refs.thumbnails, {
      fixedWidth: 125,
      fixedHeight : 90,
      gap : 10,
      rewind : true,
      pagination : false,
      arrows: false,
      isNavigation: true,
      breakpoints : {
        600: {
          fixedWidth : 60,
          fixedHeight: 44,
        },
      },
    })

    this.splide.sync( this.thumbnails )
    this.splide.mount()
    this.thumbnails.mount()

    this.lightbox = GLightbox({
      selector: '[data-glightbox]',
      loop: true,
      openEffect: 'fade',
      closeEffect: 'fade',
      width: '90vw',
      height: '90vh',
      maxWidth: '1200px',
      maxHeight: '800px',
    })

    this.lightbox.on('slide_changed', ({ prev, current }) => {
      // Update position of the slider
      this.splide.go( current.index )
      this.thumbnails.go( current.index )
    })

    this.thumbnails.on('mounted move', () => {
      this.currentIndex = this.thumbnails.index
    })

    this.splide.on('mounted move', () => {
      this.currentIndex = this.splide.index
    })

  },

  goTo(index) {
    this.splide.go(index)
    this.thumbnails.go(index)
  },

})
